import styles from '../MaterialPreviewModal.module.css';
import { Tooltip } from '../../../common/Tooltip';
import type { MaterialAction } from './useMaterialActions';

const VARIANT_CLASS: Record<NonNullable<MaterialAction['variant']>, string> = {
  default: 'btn-modal',
  danger: 'btn-modal-danger',
  sub: 'btn-modal-sub',
};

const ICON_STYLE = { width: '16px', height: '16px' } as const;
const ICON_STYLE_WITH_LABEL = { width: '16px', height: '16px', marginRight: '6px' } as const;

/**
 * desktop フッターのボタン 1 個。
 * iconOnly のときはラベルを出さず Tooltip で意味を伝える。
 */
export function MaterialActionButton({ action }: { action: MaterialAction }) {
  const button = (
    <button
      type="button"
      className={VARIANT_CLASS[action.variant ?? 'default']}
      onClick={action.onClick}
      disabled={action.disabled}
    >
      <img src={action.icon} alt="" style={action.iconOnly ? ICON_STYLE : ICON_STYLE_WITH_LABEL} />
      {!action.iconOnly && <span className={styles.buttonText}>{action.label}</span>}
    </button>
  );

  if (!action.iconOnly) return button;

  // 非活性なら理由を、そうでなければ通常の説明を出す
  const tooltip = (action.disabled && action.disabledReason) || action.tooltip;
  return tooltip ? <Tooltip content={tooltip}>{button}</Tooltip> : button;
}
